<ng-container *ngIf="!(srvRpDesign.isMobile$ | async)">
  <div class="bg-white p-5">
    <div class="font-dialog-error-title d-flex justify-content-center" [ngStyle]="UIUtilityService.getHeaderStyle()">
      {{ data.title }}
    </div>

    <div class="item-center m-5" *ngIf="!data.image">
      <mat-icon svgIcon="falTimesCircle" class="icon-center icon-size-70" [ngStyle]="UIUtilityService.getDangerIconStyle()"></mat-icon>
    </div>

    <div class="item-center m-5" *ngIf="data.image">
      <img [src]="data.image" class="icon-center icon-size-70" [ngStyle]="UIUtilityService.getDangerIconStyle()">
    </div>

    <div class="mt-3 mx-1 font-dialog-error-content" mat-dialog-content>
      <p *ngFor="let msg of data.msgs">{{ msg }}</p>
    </div>

    <div class="mt-3 d-flex justify-content-center" mat-dialog-actions>
      <button class="py-4 font-button button-action-cancel" mat-button [mat-dialog-close]="" cdkFocusInitial>
        {{ data.buttonText }}
      </button>
    </div>
  </div>
</ng-container>

<ng-container *ngIf="(srvRpDesign.isMobile$ | async)">
  <div class="bg-white p-3">
    <div class="font-dialog-error-title d-flex justify-content-center" [ngStyle]="UIUtilityService.getHeaderStyle()">
      {{ data.title }}
    </div>

    <div class="item-center m-3" *ngIf="!data.image">
      <mat-icon svgIcon="falTimesCircle" class="icon-center icon-size-50" [ngStyle]="UIUtilityService.getDangerIconStyle()"></mat-icon>
    </div>

    <div class="item-center m-3" *ngIf="data.image">
      <img [src]="data.image" class="icon-center icon-size-50" [ngStyle]="UIUtilityService.getDangerIconStyle()">
    </div>

    <div class="mb-3 mobile-font-dialog-error-content">
      <div *ngFor="let msg of data.msgs" class="mb-2">{{ msg }}</div>
    </div>

    <div class="d-flex justify-content-center">
      <button class="py-4 font-button button-action-cancel" mat-button [mat-dialog-close]="" cdkFocusInitial>
        {{ data.buttonText }}
      </button>
    </div>
  </div>
</ng-container>